import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import Lightbox from '../components/Lightbox';
import './Immigration.css';

const Biotech = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState({ src: '', alt: '' });

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage({ src: '', alt: '' });
  };

  return (
    <PageLayout 
      title="Biotech & Healthcare Innovation" 
      subtitle="Harnessing nanotechnology to improve global health by enabling correlation between personal health and personal environment, empowering patients and doctors to manage wellness and improve quality of life."
    >
      <section className="immigration-section">
        <div className="container">
          <div className="immigration-intro">
            <h2>Healthcare Innovation</h2>
            <p>
              We integrate life sciences and bioprocess engineering with the goal of producing advanced manufacturing technologies that fundamentally transform treatment of human diseases and injuries.
            </p>
          </div>
          
          <div className="tab-content">
            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Nanotechnology & Bioengineering</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Our vision harnesses nanotechnology to improve global health by enabling correlation between personal health and personal environment, empowering patients and doctors to manage wellness and improve quality of life.
                  </p>
                  
                  <div className="info-section">
                    <h4>Core Technologies</h4>
                    <ul>
                      <li>Integrated engineering technologies and biological discoveries</li>
                      <li>Clinical expertise in advanced manufacturing</li>
                      <li>Infrastructure to transform treatment of diseases and injuries</li>
                      <li>Technologies that enhance the body's ability to heal itself</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Revolutionary Applications</h4>
                    <ul>
                      <li>Surgical systems with novel computer interfaces</li>
                      <li>Human/machine interface technologies</li>
                      <li>Enhanced surgical procedures for better outcomes</li>
                      <li>Cost-effective treatment solutions</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="Nanotechnology & Bioengineering" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Nanotechnology & Bioengineering')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Microbial Research & Solutions</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We focus on fundamental discoveries about microbial communities on surfaces, partnering with market leaders in developing innovative solutions for microbial biofilms and robotic nano cleaning technologies.
                  </p>
                  
                  <div className="info-section">
                    <h4>Research Areas</h4>
                    <ul>
                      <li>Fundamental discoveries about microbial communities</li>
                      <li>Surface microbiology and biofilm formation</li>
                      <li>Advanced cleaning and disinfection technologies</li>
                      <li>Covid pandemic-inspired research solutions</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Technology Solutions</h4>
                    <ul>
                      <li>Robotic nano cleaning technologies</li>
                      <li>Microbial biofilm treatment systems</li>
                      <li>Surface sterilization innovations</li>
                      <li>Automated disinfection platforms</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1582719471384-894fbb16e074?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="Microbial Research" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1582719471384-894fbb16e074?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Microbial Research')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Advanced Medical Technologies</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We develop and translate new technologies that enhance the body's ability to heal itself, supporting revolutionary surgical procedures that extend surgeon's abilities to achieve better outcomes at lower costs.
                  </p>
                  
                  <div className="info-section">
                    <h4>Surgical Innovation</h4>
                    <ul>
                      <li>Novel computer and human/machine interface technologies</li>
                      <li>Revolutionary surgical procedures and techniques</li>
                      <li>Enhanced surgeon capabilities and precision</li>
                      <li>Improved patient outcomes and recovery</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Technology Development</h4>
                    <ul>
                      <li>Advanced manufacturing for medical devices</li>
                      <li>Body's natural healing enhancement systems</li>
                      <li>Cost-effective treatment delivery platforms</li>
                      <li>Next-generation therapeutic approaches</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="Advanced Medical Technologies" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Advanced Medical Technologies')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="immigration-service-card">
            <div className="service-header">
              <h3>Why Choose Our Biotech Solutions?</h3>
            </div>
            <div className="service-content">
              <div className="service-text">
                <p style={{fontSize: '1.1rem', marginBottom: '30px'}}>
                  We integrate life sciences and bioprocess engineering with advanced manufacturing technologies to fundamentally transform treatment of human diseases and injuries.
                </p>
                
                <div className="info-section">
                  <h4>Cutting-Edge Research</h4>
                  <p>Fundamental discoveries in nanotechnology and microbial research driving healthcare innovation.</p>
                </div>
                
                <div className="info-section">
                  <h4>Advanced Manufacturing</h4>
                  <p>State-of-the-art bioprocess engineering and manufacturing technologies for medical applications.</p>
                </div>
                
                <div className="info-section">
                  <h4>Clinical Translation</h4>
                  <p>Seamless translation from research discoveries to clinical applications and patient care.</p>
                </div>
                
                <div className="info-section">
                  <h4>Market Leadership</h4>
                  <p>Strategic partnerships with industry leaders to bring innovative solutions to market.</p>
                </div>
                
                <div style={{marginTop: '32px', padding: '24px', background: 'rgba(0,0,0,0.05)', borderRadius: '12px'}}>
                  <p style={{margin: '0', fontSize: '1rem', lineHeight: '1.6', fontStyle: 'italic'}}>
                    Our vision harnesses nanotechnology to improve global health by enabling correlation between personal health and personal environment, empowering patients and doctors to manage wellness and improve quality of life through revolutionary technological solutions.
                  </p>
                </div>
              </div>
              <div className="service-image">
                <img 
                  src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                  alt="Biotech Innovation Excellence" 
                  onClick={() => openLightbox('https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Biotech Innovation Excellence')}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
          </div>
          
          <div className="immigration-page-cta-section">
            <h3>Transform Healthcare with Innovation</h3>
            <p>Ready to partner with us in developing breakthrough medical technologies? Contact our biotech specialists.</p>
            <a href="/contact" className="btn immigration-btn-primary">Explore Opportunities</a>
          </div>
        </div>
      </section>
      
      <Lightbox 
        isOpen={lightboxOpen}
        imageSrc={lightboxImage.src}
        imageAlt={lightboxImage.alt}
        onClose={closeLightbox}
      />
    </PageLayout>
  );
};

export default Biotech;